"use client";
import { type Props, ReactSVG } from "react-svg";
import { useBrandPatternURL } from "@/hooks/useBrandPatternURL";

export type SVGEmbedProps = Omit<Props, "ref" | "src"> & {
  src?: string;
};

export default function SVGEmbed({ src, ...restProps }: SVGEmbedProps) {
  const url = useBrandPatternURL(src);

  return url ? <ReactSVG src={url} {...restProps} /> : null;
}
